import { QueryKey, MutationKey } from '@tanstack/react-query';

export const copyQueryTags: QueryKey = ['copy', 'service', 'query'];
export const retrieveCopyTags: QueryKey = ['copy', 'retrieve'];

export const createCopyMutationKey: MutationKey = ['copy', 'mutation', 'create'];
export const updateCopyMutationKey: MutationKey = ['copy', 'mutation', 'update'];
export const deleteCopyMutationKey: MutationKey = ['copy', 'mutation', 'delete'];
